// extracted by mini-css-extract-plugin
export default {"toggleContainer":"OverviewToggle_toggleContainer__uXK0U","toggleButton":"OverviewToggle_toggleButton__nvt+F","active":"OverviewToggle_active__UdaGw"};